// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body .vs__dropdown-menu{z-index:10050!important}", ""]);
// Exports
module.exports = exports;
